const baseStyle = {}

const defaultProps = {
  size: 'md',
  variant: 'light',
}

const parts = ['container', 'icon', 'dt', 'dd']

const sizes = {
  sm: {
    container: {
      fontSize: 'sm',
      lineHeight: '22px',
    },
    dt: {
      fontSize: 'sm',
      spaceX: 4,
    },
    dd: {
      fontSize: 'sm',
      spaceX: 4,
    },
    icon: {
      size: 'sm',
      mx: 0.5,
      my: 'auto',
    },
  },
  md: {
    container: {
      fontSize: 'md',
      lineHeight: '30px',
    },
    dt: {
      fontSize: 'md',
      spaceX: 6,
    },
    dd: {
      fontSize: 'md',
      spaceX: 6,
    },
    icon: {
      size: 'md',
      mx: 0.5,
      my: 'auto',
    },
  },
}

const variants = {
  light: {
    container: {
      color: 'sandstone.20',
    },
  },
  dark: {
    container: {
      bg: 'darkBlue.main',
      color: 'white',
    },
  },
}

export default {
  baseStyle,
  defaultProps,
  parts,
  sizes,
  variants,
}
